import Papa, { ParseLocalConfig } from "papaparse";
import { Readable } from "stream";

const sharedConfig = {
  delimiter: ",",
  header: true,
  skipEmptyLines: true,
  chunk: undefined,
  chunkSize: undefined,
  delimitersToGuess: [",", "\t", "|", ";", Papa.RECORD_SEP, Papa.UNIT_SEP],
};

const config = {
  ...sharedConfig,
  worker: true,
};

export const parseCSVClient = <T>(
  csv: File,
  {
    onComplete,
    onError,
    config: userConfig,
  }: {
    onComplete: (results: Papa.ParseResult<T>) => void;
    onError: (error: Error, file: File) => void;
    config?: Partial<ParseLocalConfig<T>>;
  }
) => {
  if (typeof window === "undefined") {
    throw new Error("parseCSVClient can only be used on the client");
  }
  return Papa.parse<T>(csv, {
    ...config,
    ...userConfig,
    complete: onComplete,
    error: onError,
  });
};

export const parseCSVServer = async <T>(csv: File): Promise<Array<T>> => {
  if (typeof window !== "undefined") {
    throw new Error("parseCSVServer can only be used on the server");
  }
  // workaround for csv.stream() not playing nice with papaparse
  // https://github.com/mholt/PapaParse/issues/466#issuecomment-2679061652
  const file = await csv.arrayBuffer();
  const buffer = Buffer.from(file);
  const stream = Readable.from(buffer);
  return new Promise(resolve => {
    Papa.parse<T>(stream, {
      ...sharedConfig,
      encoding: "utf-8",
      complete: results => {
        resolve(results.data);
      },
    });
  });
};
